import { PractitionersState, ProvidersState, ProviderState } from './types'

export const providersSelector = (state: any): ProvidersState => state.providers.providers

export const providerSelector = (state: any): ProviderState => state.providers.provider

export const practitionersSelector = (state: any): PractitionersState => state.providers.practitioners
